import { mapJsonQuery } from './jsonQuery';
import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { ITag } from '../types/tags';

export const mapTags = (promosResponse: ISearchPromosV2ResponseSchema): ITag[] => {
  return promosResponse.tags.map(tag => ({
    jsonQuery: mapJsonQuery(tag.jsonQuery),
    name: tag.name,
  }));
};
